'use client';

export { FrameBrowser, type FrameT } from './FrameBrowser';
